import { QuestionForMain } from "@/components/features/_layouts/island/main/question";

import { InputNumberFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-number";
import { InputTextFieldRHF } from "@/components/ui/form/fields-rhf/input-field/input-text";

import { useGoogleFreeBookingLinksSettingsContext } from "../../../_context";

export const FormAddress = () => {
	const { form } = useGoogleFreeBookingLinksSettingsContext();
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<QuestionForMain
			title={"住所"}
			required
			inputChildren={
				<div className="flex flex-col gap-6">
					<p>Googleの規約上、住所を公開していない施設は無料予約リンクの機能を利用できません。</p>

					<div className="flex flex-col gap-2">
						<InputTextFieldRHF
							label="郵便番号"
							className="w-32"
							errorMessage={errors?.address?.postalCode?.message}
							{...register("address.postalCode")}
						/>

						<InputTextFieldRHF
							label="都道府県"
							className="w-32"
							errorMessage={errors?.address?.province?.message}
							{...register("address.province")}
						/>

						<InputTextFieldRHF
							label="市区町村"
							className="w-2/3 min-w-72"
							errorMessage={errors?.address?.city?.message}
							{...register("address.city")}
						/>

						<InputTextFieldRHF
							label="市区町村以降（任意）"
							className="w-2/3 min-w-72"
							errorMessage={errors?.address?.addr1?.message}
							{...register("address.addr1")}
						/>
					</div>
					<div className="flex max-w-60 flex-col gap-4">
						<div className="flex items-end gap-2">
							<InputNumberFieldRHF
								label="緯度"
								needsDecimal
								textAlign="left"
								errorMessage={errors?.geoLocation?.lat?.message}
								hiddenSpinButton
								{...register("geoLocation.lat", { valueAsNumber: true })}
							/>
							<p>度</p>
						</div>

						<div className="flex items-end gap-2">
							<InputNumberFieldRHF
								label="経度"
								needsDecimal
								textAlign="left"
								errorMessage={errors?.geoLocation?.lon?.message}
								hiddenSpinButton
								{...register("geoLocation.lon", { valueAsNumber: true })}
							/>
							<p>度</p>
						</div>
					</div>
				</div>
			}
		/>
	);
};
